import React, { PureComponent } from 'react';

class RenglonDatosAdicionales extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    handleTipoReferenciaChange = (event) => {
        const {registro, onValorReferenciaChange, cuentasContables, OnInputValorReferencia} = this.props;
        let cuentaContableSeleccionada = cuentasContables && cuentasContables.find(cuenta => cuenta.Codigo == registro.CuentaContableCodigo)

        onValorReferenciaChange(registro.renglonId, event.target.value)
        OnInputValorReferencia(registro.renglonId, "")

        if(event.target.value == 2 && (cuentaContableSeleccionada && cuentaContableSeleccionada.ValorReferencia)){
            OnInputValorReferencia(registro.renglonId, cuentaContableSeleccionada.ValorReferencia) 
        }

    };
    
    handleInputReferenciaChange = (event) => {
        const {registro, OnInputValorReferencia} = this.props;
        OnInputValorReferencia(registro.renglonId, event.target.value)
    };

    handleTipoMovimientoClick = (parametrosDescargaExcel) => {
        const { descargaTipoMovimiento } = this.props;
        descargaTipoMovimiento(parametrosDescargaExcel);
    };

    handleCentroCostoChange = (event) => {
        const {registro, onCentroCostoChange} = this.props;
        onCentroCostoChange(registro.renglonId, event.target.value)
    };


    render() {
        const {
            estaDesplegado,
            registro,
            registroAsientoContable,
            centrosCosto,
            cuentasContables,
            renglonAgregadoManualmente,
            renglonManual,
            onRenglonEliminado,
            tienePermisoModificacion
        } = this.props;

        let valorComboValorReferencia = registro && registro.TipoReferencia ? registro.TipoReferencia : "0"
        let valorComboCentroCosto = registro && registro.CentroCostoId ? registro.CentroCostoId : "0"
        let valorInputReferencia = registro && registro.ReferenciaRenglon ? registro.ReferenciaRenglon : ""

        let muestraCestoEliminacion = (renglonAgregadoManualmente || renglonManual || registro && registro.TipoRenglon == 2) && tienePermisoModificacion;
        let habilitaLetraItalic = renglonAgregadoManualmente || renglonManual || registro && registro.TipoRenglon == 2;
        
        let tipoRenglonTexto = "";
        let tipoAperturaTexto = "";
        let centroCostosTexto = "";
        let tipoMovimientoTexto = "";
        let signoTexto = "";
        let tipoReferenciaTexto = "";
        let referenciaRenglonTexto = "";
        let centrosDeCosto= [];

        if(registro){
            switch (registro.TipoRenglon) {
                case 1:
                    tipoRenglonTexto = "Automático";
                    break;
                case 2:
                    tipoRenglonTexto = "Manual";
                    break;
                case 3:
                    tipoRenglonTexto = "Balanceo Automático";
                    break;
                default:
                    tipoRenglonTexto = "";
            }
        
            switch (registro.TipoApertura) {
                case 1:
                    tipoAperturaTexto = "Sin Apertura";
                    break;
                case 2:
                    tipoAperturaTexto = "Socio";
                    break;
                case 3:
                    tipoAperturaTexto = "Movimiento";
                    break;
                default:
                    tipoAperturaTexto = "";
            }

            if (registro.CentroCostoCodigo && registro.CentroCostoDescripcion){
                centroCostosTexto = registro.CentroCostoCodigo + " - " + registro.CentroCostoDescripcion;
            } else{
                
                switch(registro.CentroCostoCodigo) {
                    case 0:
                        centroCostosTexto = "Ninguno";
                        break;
                    default:
                        centroCostosTexto = "Asociado a la sucursal";
                        break;
                }
            }
       

            if (registro.TipoRenglon === 1) {
                tipoMovimientoTexto = registro.TipoMovimientoDescripcion;
            }
        
            if (registro.TipoRenglon === 1) {
                signoTexto = registro.SignoCampo;
            }
        
            switch (registro.TipoReferencia) {
                case 0:
                    tipoReferenciaTexto = "Ninguna";
                    break;
                case 1:
                    tipoReferenciaTexto = "Referencia Socio";
                    break;
                case 2:
                    tipoReferenciaTexto = "Referencia Cuenta Contable";
                    break;
                case 3:
                    tipoReferenciaTexto = "Referencia Renglón ";
                    break;
                default:
                    tipoReferenciaTexto =  "Ninguna";
            }

           registro.ReferenciaRenglon ?  referenciaRenglonTexto = " (" + registro.ReferenciaRenglon + ")" : "" ;
        }

        renglonAgregadoManualmente && centrosCosto ? centrosDeCosto = centrosCosto.map(centro => (
            <option key={centro.Id} value={centro.Id}>{centro.Descripcion}</option>
        )) : null

        let cuentaContableSeleccionada = cuentasContables && cuentasContables.find(cuenta => cuenta.Codigo == registro.CuentaContableCodigo)

        let descripcionCuentaContable = cuentaContableSeleccionada && cuentaContableSeleccionada.ValorReferencia ? `Cuenta Contable (${cuentaContableSeleccionada.ValorReferencia})` : "Cuenta Contable (Sin referencia)";

        let parametrosDescargaExcel = registro && registroAsientoContable ? {
            AsientoCabeceraId: registro.CabeceraAsientoId,
            ModeloCabeceraId: registroAsientoContable.ModeloCabeceraId,
            ModeloDescripcion: registroAsientoContable.ModeloCabeceraDescripcion,
            ModeloDetalleId: registro.ModeloDetalleId,
            MonedaDescripcion: registroAsientoContable.MonedaDescripcion,
            NroRenglon: registro.NroRenglon,
            SucursalDescripcion: registroAsientoContable.SucursalDescripcion,
            TipoApertura: registro.TipoApertura,
            ValorApertura: registro.ValorApertura,
        } : null;

        return (
            <div className={"AsientosContables__modalDetalleAsiento__registrosAdicionales AsientosContables__modalDetalleAsiento__registrosAdicionales--maxHeightDetalleAsiento AsientosContables--overflowHidden slider-tarjetas" + (estaDesplegado ? "" : " closed AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorAuditoriaReproceso--Inactivo") + (habilitaLetraItalic ? " letra-cursiva-grilla-renglones" : "")}>
                <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__registrosAdicionalesColumnaIzquierda">
                    {renglonAgregadoManualmente ?
                        <div className="contenedorCombosDatosAdicionalesRenglonManual" >
                            <span>Centro de costos:</span>
                            <select className="comboDatosAdicionalesRenglonManual" value={valorComboCentroCosto} onChange={this.handleCentroCostoChange}>
                            <option key="0" value="0">Ninguno</option>
                            {centrosDeCosto}
                            </select>
                        </div> :
                        <div>
                           <div className="AsientosContables__modalDetalleAsiento__registrosAdicionalesDatosSuperiores">Tipo renglón: <span>{tipoRenglonTexto}</span></div>
                            <div className="AsientosContables__modalDetalleAsiento__registrosAdicionalesDatosCentrales">Centro de costos: <span>{centroCostosTexto}</span></div>
                            <div className="AsientosContables__modalDetalleAsiento__registrosAdicionales--tipoReferencia">Tipo Referencia: <span>{tipoReferenciaTexto}{referenciaRenglonTexto}</span></div>
                        </div>
                    }
                </div>  

                <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__registrosAdicionalesColumnaCentro">
                {renglonAgregadoManualmente ?
                        <div className="contenedorCombosDatosAdicionalesRenglonManual">
                            <span>Tipo de referencia:</span>
                            <div className="contenedorCombosDatosAdicionalesRenglonManual--width">    
                            <select className="comboDatosAdicionalesRenglonManual" value={valorComboValorReferencia} onChange={this.handleTipoReferenciaChange}>
                                <option key="0" value="0">Ninguna</option>
                                <option key="2" value="2">{descripcionCuentaContable}</option>
                                <option key="3" value="3">Otra</option>
                            </select>
                                {valorComboValorReferencia === "3" && (
                                <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__registrosAdicionalesColumnaDerecha">
                                    <input type="text" className="inputDatosAdicionalesRenglonManual" placeholder="Valor de referencia"  value={valorInputReferencia} onChange={this.handleInputReferenciaChange}/>
                                </div>
                                )}
                            </div>
                         </div>
                         :
                        <div>
                            {registro && registro.TipoRenglon == 1 ?  <div className="AsientosContables__modalDetalleAsiento__registrosAdicionalesDatosSuperiores">Tipo apertura: <span>{tipoAperturaTexto}</span></div> : null}
                            {registro && registro.TipoRenglon == 1 ? <div>Tipo de movimiento: <span className="AsientosContables__modalDetalleAsiento__registrosAdicionalesTipoMovimiento" onClick={parametrosDescargaExcel ? () => this.handleTipoMovimientoClick(parametrosDescargaExcel) : null}>{tipoMovimientoTexto}</span></div> : null}
                        </div>
                      }
                </div>
                {!renglonAgregadoManualmente ?
                 <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__registrosAdicionalesColumnaDerecha">
                    {registro && registro.TipoRenglon == 1 ?  <div className="AsientosContables__modalDetalleAsiento__registrosAdicionalesDatosSuperiores">Campo: <span>{registro && registro.CampoImporteDescripcion}</span></div> : null}
                    {registro && registro.TipoRenglon == 1 ?  <div>Signo: <span>{signoTexto}</span></div> : null}
                </div> 
                : null }

            { muestraCestoEliminacion ? 
                <div className="seccionRenglonesModelo__renglonModelo__accionEliminar AsientosContables__modalNuevoAsiento__datosAdicionalesContenedorBotonEliminar AsientosContables__marginBotonEliminarRenglon"  onClick={() => onRenglonEliminado(registro.renglonId)}></div>
                : null}
            </div>    
        );        
    }
}    

export default RenglonDatosAdicionales;